import { Alert, Box, Dialog, DialogContent } from "@mui/material";
import PropTypes from "prop-types";

import { formatDateTime } from "@/features/shared";
import { CustomDialogTitle } from "@/features/ui";

/**
 * Prints exactly the applied generation: the captured HTML string is loaded, unmodified,
 * into a new temporary frame. No request is made and no data is refetched. The frame
 * allows only scripts (the fixed, CSP-hashed print bootstrap in the document) and modals
 * (window.print). It never gets allow-same-origin, so it cannot reach this app, and it is
 * destroyed when the dialog closes.
 */
export const InventoryValueReportPrintDialog = ({ open, reportDocument, onClose }) => {
  const { html, metadata } = reportDocument;

  return (
    <Dialog open={open} onClose={onClose} fullScreen>
      <CustomDialogTitle title="Cetak Nilai Persediaan" onClose={onClose} />
      <DialogContent
        sx={{ display: "flex", flexDirection: "column", gap: 1, pb: 2 }}
      >
        <Alert severity="info">
          Mencetak laporan yang sedang ditampilkan (ID {metadata.reportId},
          dibuat {formatDateTime(metadata.generatedAt)}) tanpa mengambil data
          baru. Tekan tombol Cetak di dalam dokumen; pilih &quot;Simpan sebagai
          PDF&quot; pada dialog cetak untuk membuat PDF. Untuk angka terbaru,
          tutup lalu Cari atau Terapkan ulang. Nomor dan batas halaman mengikuti
          browser.
        </Alert>
        <Box
          component="iframe"
          key={metadata.reportId}
          title="Pratinjau cetak Nilai Persediaan"
          srcDoc={html}
          sandbox="allow-scripts allow-modals"
          referrerPolicy="no-referrer"
          sx={{
            flex: 1,
            minHeight: "70vh",
            width: "100%",
            border: 1,
            borderColor: "divider",
          }}
        />
      </DialogContent>
    </Dialog>
  );
};

InventoryValueReportPrintDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  reportDocument: PropTypes.shape({
    html: PropTypes.string.isRequired,
    metadata: PropTypes.shape({
      reportId: PropTypes.string.isRequired,
      generatedAt: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
};
